import { catchError, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { Room } from '../../model/room';
import { ApiVersions } from '../../../core/model/const/api-versions';
@Injectable()
export class RoomService {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this._endpoint = `${config.apiEndpointV2}/room`;
  }

  private readonly _endpoint: string;

  getByRentalObject(rentalObjectId: string): Observable<Room[]> {
    return this._client.get<Room[]>(`${this._endpoint}/rental-object/${rentalObjectId}`).pipe(
      map(data => data.map(item => Object.assign(new Room(), item))),
      catchError(error => {
        this._messageService.showError(error);
        return [];
      })
    );
  }
}
